module.exports = __webpack_public_path__ + "staticesp/media/marcasr.3bf59fd1.jpg";